"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingId = void 0;
/**
 * The different kinds of onboarding. Can be either "HL" or "HOD".
 */
var OnboardingId;
(function (OnboardingId) {
    /**
     * Happy Leaver
     */
    OnboardingId["HL"] = "HL";
    /**
     * Host on Demand
     */
    OnboardingId["HOD"] = "HOD";
})(OnboardingId = exports.OnboardingId || (exports.OnboardingId = {}));
//# sourceMappingURL=OnboardingId.js.map